import React from 'react';
import type { IconProps } from '../types';

export const IconQuoteBoard: React.FC<IconProps> = ({ size = 20, className = '', color = 'currentColor' }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    {/* Quote board - grid/table icon */}
    <rect x="2" y="3" width="16" height="14" rx="1" stroke={color} strokeWidth="1.5"/>
    {/* Horizontal dividers */}
    <line x1="2" y1="7" x2="18" y2="7" stroke={color} strokeWidth="1.5"/>
    <line x1="2" y1="11" x2="18" y2="11" stroke={color} strokeWidth="1.5"/>
    {/* Vertical divider */}
    <line x1="10" y1="3" x2="10" y2="17" stroke={color} strokeWidth="1.5"/>
    {/* Price indicators */}
    <path d="M5 5L7 5" stroke={color} strokeWidth="1.2" strokeLinecap="round"/>
    <path d="M13 5L15 5" stroke={color} strokeWidth="1.2" strokeLinecap="round"/>
  </svg>
);
